import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Homeworks.css';
const gangaSweetsCover = 'https://ascentbw.com/Images/Gangasweets/Full1.webp';
const canineHeroImg = 'https://ascentbw.com/Images/CanineCrown/CanineCover.webp';
const feston = 'https://ascentbw.com/Images/Feston/cover.webp';

const Homeworks = () => {
  const navigate = useNavigate();

  const works = [
    {
      id: 1,
      title: 'Ganga Sweets – Packaging & Brand Identity',
      img: gangaSweetsCover,
      path: '/works/gangasweets'
    },
    {
      id: 2,
      title: 'Canine Crown - Premium Pet Nutrition Brand',
      img: canineHeroImg,
      path: '/works/canine-crown'
    },
    {
      id: 3,
      title: 'Feston – Renewable Energy Brand Experience',
      img: feston,
      path: '/works/feston'
    }
  ];

  return (
    <section className="homeworks-section">
      <div className="homeworks-container">
        <div className="homeworks-header">
          <h2 className="homeworks-title">Featured Works</h2>
          <button className="homeworks-view-all" onClick={() => navigate('/works')}>View All Projects</button>
        </div>
        
        <div className="homeworks-grid">
          {works.map((work) => (
            <div key={work.id} className="homeworks-card" onClick={() => navigate(work.path)}>
              <div className="homeworks-card-image">
                <img src={work.img} alt={work.title} />
              </div>
              <h3 className="homeworks-card-title">{work.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Homeworks;
